module.exports = __webpack_public_path__ + "static/media/pharmacyOutlets.a8449325.jpg";